const STORAGE_KEY = 'acem_user_profile';

/**
 * Sauvegarde les informations utilisateur issues des étapes précédentes (ex: formulaire de recensement)
 * @param {Object} data 
 */
export function saveUserProfile(data) {
  if (!data) return;
  try {
    const existing = getUserProfile() || {};
    const updated = {
      ...existing,
      ...data,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (err) {
    console.warn("Impossible de sauvegarder le profil utilisateur dans le stockage local:", err);
  }
}

/**
 * Récupère les informations utilisateur sauvegardées lors des étapes précédentes
 * @returns {Object|null}
 */
export function getUserProfile() {
  try {
    const item = localStorage.getItem(STORAGE_KEY);
    return item ? JSON.parse(item) : null;
  } catch (err) {
    console.warn("Impossible de lire le profil utilisateur depuis le stockage local:", err);
    return null;
  }
}

/**
 * Efface le profil utilisateur stocké
 */
export function clearUserProfile() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.warn("Erreur lors de la suppression du profil utilisateur:", err);
  }
}
